import React from 'react';
import styled from 'styled-components';
import withTileAction from '../../../util/withTileAction';
import Controller from './components/Controller';
import { safeGet } from '../../../../../../../core/util/object';
import { getInsuranceCarrierCardDisplayProperties } from '../../../../../../../core/util/insurance';
import ObserverContainer from '../../../../../../SolvPatternLibrary/Profilers/Observer';
import { analyticsTrackEvent } from '../../../../../../../core/analytics';
import { ACTION_SEE_TILE } from '../../../../../../../core/analytics/events';

const Root = styled.div.withConfig({ componentId: 'sc-kwcnt0-0' })`
  cursor: pointer;
`;

type Props = {
  doTileAction?: (...args: any[]) => any;
  tile: any;
  tileIndex: number;
  userProfile: any;
  insuranceDetails?: any;
  insuranceProfile?: any;
};

const SpendTracker = (props: Props) => {
  const { tileIndex, tile, userProfile, doTileAction, insuranceDetails, insuranceProfile } = props;

  const handleClick = (e: any) => {
    e && e.preventDefault();

    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    doTileAction(tileIndex, tile, userProfile, null);
  };

  const displayProps = getInsuranceCarrierCardDisplayProperties(
    safeGet(insuranceProfile)('insurer_code')
  );

  return (
    <Root onClick={handleClick}>
      <ObserverContainer
        handleSawComponent={() =>
          analyticsTrackEvent('Insurance Spend Widget', { action: ACTION_SEE_TILE })
        }
      >
        {/* @ts-expect-error ts-migrate(2786) FIXME: Type 'false' is not assignable to type 'Element | ... Remove this comment to see the full error message */}
        <Controller
          insuranceCarrierName={safeGet(insuranceProfile)('insurer_name')}
          insuranceDetails={insuranceDetails}
          // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type 'string'.
          logo={displayProps && displayProps.logo}
          userProfileId={userProfile.user_profile_id}
        />
      </ObserverContainer>
    </Root>
  );
};

export default withTileAction(SpendTracker);
